import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {PurchaseOrderConverter} from '../../../api/entity/converter/purchaseOrder.converter';
import {PurchaseOrderModel} from '../../../api/entity/purchaseOrder.model';

@Injectable({providedIn: 'root'})
export class PurchaseOrderDataService
    extends AbstractDataServiceV2<PurchaseOrderModel, PurchaseOrderConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: PurchaseOrderConverter) {
        super('PurchaseOrder', http, httpUrlGenerator, logger, config, converter);
    }
}
